import React from 'react'

const Offers = () => {
    return (
        <div>
             {/* <!-- Latest offers Start --> */}
            <div className="latest-offers categories content-area-7">
                <div className="container">
                    {/* <!-- Main title --> */}
                    <div className="main-title text-center">
                        <h1>Ultimas Ofertas</h1>
                        <p>Aqui podras encontrar las ofertas mas fresquesitas que tenemos solo para ti.</p>
                    </div>
                    <div className="row row-2">
                        <div className="col-lg-7 col-md-12">
                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-pad">
                                    <div className="category">
                                        <div className="category_bg_box cat-1-bg">
                                            <div className="category-overlay">
                                                <div className="category-content">
                                                    <div className="new">Nacional</div>
                                                    <div className="lo-text clearfix">
                                                        <div className="price-box-2"><sup>$</sup>650<span>/dlls</span></div>
                                                        <h3 className="category-title">
                                                            <a href="#">Ford Focus 2012</a>
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6 col-pad">
                                    <div className="category">
                                        <div className="category_bg_box cat-2-bg">
                                            <div className="category-overlay">
                                                <div className="category-content">
                                                    <div className="new">Nacional</div>
                                                    <div className="lo-text clearfix">
                                                        <div className="price-box-2"><sup>$</sup>740<span>/dlls</span></div>
                                                        <h3 className="category-title">
                                                            <a href="#">Jeep Liberty 2012</a>
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-6 col-pad">
                                    <div className="category">
                                        <div className="category_bg_box cat-3-bg">
                                            <div className="category-overlay">
                                                <div className="category-content">
                                                    <div className="new">Fronterizo</div>
                                                    <div className="lo-text clearfix">
                                                        <div className="price-box-2"><sup>$</sup>950<span>/dlls</span></div>
                                                        <h3 className="category-title">
                                                            <a href="#">Chevrolete Sonic 2012</a>
                                                        </h3>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12 col-pad">
                            <div className="category">
                                <div className="category_bg_box category_long_bg cat-4-bg">
                                    <div className="category-overlay">
                                        <div className="category-overlay">
                                            <div className="category-content">
                                                <div className="new">Fronterizo</div>
                                                <div className="lo-text clearfix">
                                                    <div className="price-box-2"><sup>$</sup>480<span>/dlls</span></div>
                                                    <h3 className="category-title">
                                                        <a href="#">Nissan Sentra 2016</a>
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Latest offers end --> */}            
        </div>
    )
}

export default Offers


// WEBPACK FOOTER //
// ./src/components/Offers.jsx